export default "__VITE_ASSET__CUmkWdsC__"